import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { OwsLink, PersonLink, TreePersonLink } from '../../../app/Links'
import { TreeIdCells } from './TreeIdBlock'
import { getOwsSummary } from '../../../../services/owsService'
import { QueuesContext } from '../../QueuesContext'
import { getMergeChainEndPersonId } from '../../../../services/personService'
import useNotifications from '../../../../hooks/useNotifications'

export function TempleReturnsMessageSummary({ messageDetails }) {
  const { t } = useTranslation()
  const [templePlatform, setTemplePlatform] = useState()
  const { setQueuesData } = useContext(QueuesContext)
  const { error } = useNotifications()
  const osid = messageDetails?.osid
  const principal = templePlatform?.persons.find((person) => person.principal)
  const personId = principal?.identifiers['http://api.familysearch.org/temple/USYS_ID']?.[0].replace('p.', '')
  const personName = principal?.names?.[0]?.nameForms?.[0]?.fullText

  useEffect(() => {
    getOwsSummary(osid)
      .then((response) => {
        setTemplePlatform(response.data.templePlatform)
      })
      .catch((err) => {
        error(t('ows.errors.gettingOws', 'Error getting OWS'), err)
      })
  }, [error, osid, t])

  useEffect(() => {
    personId &&
      getMergeChainEndPersonId(personId)
        .then((response) => {
          setQueuesData((prevState) => {
            const result = {
              ...prevState,
              osid: { ...prevState?.osid, [osid]: { ...prevState?.osid?.[osid], personId: response.data.personId } },
            }
            return result
          })
        })
        .catch(() => {
          setQueuesData((prevState) => {
            const result = {
              ...prevState,
              osid: { ...prevState?.osid, [osid]: { ...prevState?.osid?.[osid], personId } },
            }
            return result
          })
        })
  }, [osid, personId, setQueuesData])

  return (
    <Grid>
      {/* Row */}
      {personId && personName && (
        <Cell columns={6}>
          <DataBlock
            heading={t('person.label', 'Person')}
            data={
              <>
                <PersonLink personId={personId} personName={personName} showId newTab />
                <TreePersonLink personId={personId} treeIcon newTab />
              </>
            }
          />
        </Cell>
      )}
      <Cell columns={6}>
        <DataBlock heading={t('lookup.osi', 'OWS OSID')} data={<OwsLink owsId={osid} />} />
      </Cell>
      <TreeIdCells treeId={messageDetails?.treeId} isResearcherTree={messageDetails?.researcherTree} />
    </Grid>
  )
}
